(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preloader"]) return;
  try {
    
// JavaScript to handle preloader functionality

// Fade out preloader after 4 seconds (4000 milliseconds)
$(document).ready(function() {
    setTimeout(function() {
        $('.zhd_preloader').fadeOut(50); // Fade out in 1 second (1000 milliseconds)
    }, 4000); // Show preloader for 4 seconds
});

// Hide preloader when all content including images have finished loading
$(window).on('load', function() {
    $('.zhd_preloader').fadeOut(500); // Fade out in 1 second (1000 milliseconds)
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-release-body"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const blocksPerPage = 9;
  const blocks = Array.from(document.querySelectorAll('.wbz-block-item'));
  const pagination = document.querySelector('.wbz-pagination');
  const loader = document.querySelector('.wbz-pagination-loader');
  const sectionTop = document.getElementById('wbz-section-custom');

  let currentPage = 1;
  const totalPages = Math.ceil(blocks.length / blocksPerPage);

  function showPage(page) {
    blocks.forEach((block, index) => {
      block.style.opacity = '0';
      block.style.display =
        index >= (page - 1) * blocksPerPage && index < page * blocksPerPage
          ? 'block'
          : 'none';
    });

    requestAnimationFrame(() => {
      blocks.forEach(block => {
        if (block.style.display === 'block') {
          block.style.opacity = '1';
        }
      });
    });

    document.querySelectorAll('.wbz-pagination button').forEach((btn, i) => {
      btn.classList.toggle('active', i + 1 === page);
    });

    document.querySelectorAll('.wbz-pagination-dots').forEach(dot => dot.remove());
    updatePaginationVisibility(page);

    // keep current page in sync
    pagination?.setAttribute('data-current-page', page);
  }

  function updatePaginationVisibility(currentPage) {
    const buttons = Array.from(document.querySelectorAll('.wbz-pagination button'));
    buttons.forEach(btn => (btn.style.display = 'none'));

    const visiblePages = new Set([1, totalPages]);

    for (let i = currentPage - 2; i <= currentPage + 2; i++) {
      if (i > 1 && i < totalPages) visiblePages.add(i);
    }

    let lastShown = null;

    buttons.forEach((btn, index) => {
      const page = index + 1;

      if (visiblePages.has(page)) {
        if (lastShown && page - lastShown > 1) {
          const dots = document.createElement('span');
          dots.className = 'wbz-pagination-dots';
          dots.textContent = '...';
          btn.before(dots);
        }

        btn.style.display = 'inline-block';
        lastShown = page;
      }
    });
  }

  function buildPagination() {
    // expose total pages on container
    pagination.setAttribute('data-total-pages', totalPages);
    pagination.setAttribute('data-current-page', currentPage);

    for (let i = 1; i <= totalPages; i++) {
      const btn = document.createElement('button');
      btn.textContent = i;

      btn.addEventListener('click', () => {
        if (i === currentPage) return;

        currentPage = i;
        loader?.classList.add('active');

        sectionTop?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

        setTimeout(() => {
          showPage(currentPage);
          loader?.classList.remove('active');
        }, 2000);
      });

      pagination.appendChild(btn);
    }
  }

  if (pagination && blocks.length) {
    buildPagination();
    showPage(currentPage);
  }
});



  } catch(e) { console.error(e); }
})();
})();
